import React from 'react';
import SEO from './components/SEO';
import LatestArticles from './components/LatestArticles';
import './Styles/Home.css';

function Home() {
    return (
        <section className="home-section">
            <SEO
                title="Oleg Orlenko - Father, Software Engineer & System Architect"
                description="Personal website of Oleg Orlenko - Software engineer, developer, and architect focused on research, learning, and self-improvement. Founder of Alternative Market and NoTaxi, former CTO at Scroble.com."
                keywords="evolution, teamwork, sense of self, social structures, AI ethics, modern loneliness, software engineer, system architect, technology enthusiast, winter sports, psychedelics"
                type="website"
                url="/"
            />
            <div className="content">
                <p>
                    Sportsman, software engineer, system architect, <br />
                    technology enthusiast, psychedelics user.
                </p>
                <p>
                    In love with winter sports and music <br />
                    Father of one little angel.
                </p>
                <p>
                    Founder of Alternative Market and NoTaxi<br />
                    Ex-CTO @ Scroble.com.
                </p>
                <p>
                    "I believe in the concept of the technological singularity."
                </p>
            </div>

            <LatestArticles />
        </section>
    );
}

export default Home;